import GtmUtil from 'src/assets/js/gtm_util.js'

export const SET_CURRENT_DIR = 'SET_CURRENT_DIR'
export const setCurrentDir = userState => {
  GtmUtil({ category: 'current_dir', action: userState })
  return {
    type: 'SET_CURRENT_DIR',
    payload: {
      current_dir: userState,
    },
  }
}

export const SET_CMD_HISTORY = 'SET_CMD_HISTORY'
export const setCmdHistory = userState => {
  // gtag
  if (!userState.is_tab_clicked) {
    let cmd = userState.cmd.match(/[^\s]+/g)
    // 値のcheck
    if (cmd) {
      let act = cmd[0]
      let label = cmd[1] ? cmd[1] : ''
      GtmUtil({ category: 'input_command', action: act, label: label })
    }
  }

  return {
    type: 'SET_CMD_HISTORY',
    payload: {
      dir: userState.dir,
      cmd: userState.cmd,
      date: userState.date,
      is_created: false,
      uid: userState.uid,
      index: userState.index,
      is_tab_clicked: userState.is_tab_clicked,
      is_secret_valid: false,
    },
  }
}

export const UPDATE_CLEAR = 'UPDATE_CLEAR'
export const updateClear = () => {
  return {
    type: 'UPDATE_CLEAR',
  }
}

export const UPDATE_SECRET = 'UPDATE_SECRET'
export const updateSecret = () => {
  return {
    type: 'UPDATE_SECRET',
    payload: {
      is_secret_valid: true,
    },
  }
}

export const SET_MOBILE_STATUS = 'SET_MOBILE_STATUS'
export const setMobileStatus = userState => {
  let act = userState.is_mobile ? 'SP' : 'PC'
  GtmUtil({ category: 'platform', action: act })

  return {
    type: 'SET_MOBILE_STATUS',
    payload: {
      is_mobile: userState.is_mobile,
      is_portrait: userState.is_portrait,
    },
  }
}

export const SET_IS_CMD_EXIT = 'SET_IS_CMD_EXIT'
export const setIsCmdExit = userState => {
  return {
    type: 'SET_IS_CMD_EXIT',
    payload: userState,
  }
}

export const SET_SECRET_ID = 'SET_SECRET_ID'
export const setSecretId = userState => {
  return {
    type: 'SET_SECRET_ID',
    payload: userState,
  }
}

export const SET_SECRET_CMD_VALUE = 'SET_SECRET_CMD_VALUE'
export const setSecretCmdValue = userState => {
  return {
    type: 'SET_SECRET_CMD_VALUE',
    payload: userState,
  }
}

export const SET_SECRET_PLAYED_TOGGLE = 'SET_SECRET_PLAYED_TOGGLE'
export const setSecretPlayedToggle = () => {
  return {
    type: 'SET_SECRET_PLAYED_TOGGLE',
  }
}

export const SET_IS_QUINE_PLAYING = 'SET_IS_QUINE_PLAYING'
export const setIsQuinePlaying = userState => {
  return {
    type: 'SET_IS_QUINE_PLAYING',
    payload: userState,
  }
}
